import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';

import { connect } from 'react-redux';
import { changeLoginData, login } from '../../actions/authActions';

import logo from '../../assets/img/logo-syngeos@2x.png';

class LoginPage extends Component {
    changeLoginData(field, value) {
        this.props.changeLoginData(field, value);
    }

    submitLogin(e, data) {
        e.preventDefault();

        this.props.login(data);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.loginLoading && !nextProps.loginLoading && !nextProps.loginError) {
          this.props.history.push('/dashboard');
        }
    }

    render() {
        const { loginData, loginError, intl } = this.props;

        return <section className='login section-wrapper'>
            <div className='container'>
                <div className='section-wrapper__content'>
                    <img src={logo} alt='Syngeos logo' />
                    <h3 className='section-wrapper__title'>
                        <FormattedMessage id='login.title' />
                    </h3>
                    <form className='site-form'>
                        <div className='form-group'>
                            <input
                                className='form-control'
                                id='username'
                                type='text'
                                value={loginData.username}
                                onChange={(e) => this.changeLoginData('username', e.target.value)}
                                placeholder={intl.formatMessage({id: 'login.fields.username'})}
                            />
                        </div>
                        <div className='form-group'>
                            <input
                                className='form-control'
                                id='password'
                                type='password'
                                value={loginData.password}
                                onChange={(e) => this.changeLoginData('password', e.target.value)}
                                placeholder={intl.formatMessage({id: 'login.fields.password'})}
                            />

                            {loginError && <div className='form-error'>
                                <FormattedMessage id='login.error' />
                            </div>}
                        </div>
                        <button
                            className='btn btn-accent form-control'
                            type='submit'
                            onClick={(e) => this.submitLogin(e, loginData)}
                        >
                            <FormattedMessage id='login.submit' />
                        </button>
                    </form>
                    <Link className='link-accent' to='/passwordsend'>
                        <FormattedMessage id='login.forgot_password' />
                    </Link>
                </div>
            </div>
        </section>;
    }
}

export default connect(
    (state) => ({
        loginData: state.auth.login.data || {},
        loginError: state.auth.login.error,
        loginFromTokenError: state.auth.login.errorFromToken,
        loginLoading: state.auth.login.loading,
    }),
    ({
        changeLoginData, login
    }),
)(injectIntl(LoginPage));



// WEBPACK FOOTER //
// ./src/views/LoginPage/LoginPage.js